// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:41:16

export default {
  "id": "save-the-cats-bubble-shooter",
  "slug": "save-the-cats-bubble-shooter",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ea1e352d227b4291baf854c2fa0f2e48-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ea1e352d227b4291baf854c2fa0f2e48/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Save the cats - Bubble shooter",
      "description": "Think strategically, aim, shoot and get rid of all the bubbles.\n\nExplore hundreds of levels with different levels of difficulty.\n\nBe as accurate as possible to free all the cats.\n\nBuy and use boosters on challenging levels.\n\nTo win - clear the field of all the balloons.",
      "instructions": "- Use the guide line to aim and explode the bubbles. Balls may ricochet off walls - take this into account when aiming.\n- You will see the next color of balloon in the cart. Use this in your strategy.\n- Don't forget about the shot counter!",
      "genres": [
        "Bubble Shooter"
      ],
      "tags": [
        "bubble",
        "cat",
        "cute"
      ]
    },
    "zh-CN": {
      "title": "拯救猫咪 - 气泡射击",
      "description": "战略思考，瞄准，射击，消灭所有气泡。\n\n探索数百个不同难度的关卡。\n\n尽可能准确，释放所有猫咪。\n\n在挑战关卡购买和使用助推器。\n\n要获胜 - 清除场地上所有的气球。",
      "instructions": "- 使用引导线瞄准并爆破泡泡。球可能会反弹到墙上 - 瞄准时请考虑这一点。\n- 你将在车中看到下一个气球的颜色。将其纳入你的策略。\n- 不要忘记射击计数器！",
      "genres": [
        "泡泡射击"
      ],
      "tags": [
        "泡泡",
        "猫",
        "可爱"
      ]
    },
    "zh-TW": {
      "title": "拯救貓咪 - 泡泡射擊",
      "description": "思考策略，瞄准，射擊並清空所有泡泡。\n\n探索數百個不同難度的關卡。\n\n盡可能準確以釋放所有貓咪。\n\n在挑戰關卡上購買和使用加強器。\n\n要獲勝 - 清空場地上的所有氣球。",
      "instructions": "- 使用導線來定位和爆炸泡泡。球體可能會從牆上彈回 - 射擊時考慮這一點。\n- 你將在攜帶中看到下一顆氣球的顏色。在策略中利用這一點。\n- 請勿忘記關於射擊次數的計數器！",
      "genres": [
        "泡泡射手"
      ],
      "tags": [
        "泡泡",
        "貓",
        "可愛"
      ]
    },
    "zh-HK": {
      "title": "拯救貓咪 - 泡泡射擊",
      "description": "謀定策略，準確射擊，消滅所有氣泡。\n\n探索超過百個難度各異的關卡。\n\n盡量準確，釋放所有貓咪。\n\n在挑戰關卡購買並使用加強器。\n\n要贏——清空場地上所有氣球。",
      "instructions": "- 使用導線來對準和爆炸泡泡。球可以撞到牆壁 - 對準時要考慮這一點。\n- 你會在攜帶箱看到下一顏色的氣球。將這一點用於你的策略。\n- 請不要忘記射擊計數器！",
      "genres": [
        "泡泡射擊"
      ],
      "tags": [
        "泡泡",
        "貓",
        "可愛"
      ]
    },
    "ja": {
      "title": "Save the cats - バブルシュータ",
      "description": "戦略的に考える、狙い、撃ち、すべての泡を消去せよ。\n\n数百の異なる難易度のレベルを探索せよ。\n\nすべての猫を解放するためにできるだけ正確に射撃せよ。\n\n困難なレベルでブースターを購入し、使用せよ。\n\n勝つためには、フィールド上のすべての風船を消去せよ。",
      "instructions": "- ガイドラインを使って、泡に当てて爆破してください。ボールは壁から反射することがありますので、狙いの時にこれを考慮してください。\n- カートに次の色の風船が見えるので、これを使って戦略を立ててください。\n- ショットカウンターを忘れずに！",
      "genres": [
        "バブルシューター"
      ],
      "tags": [
        "泡",
        "猫",
        "可愛い"
      ]
    },
    "ko": {
      "title": "고양이를 구하기 - 버블 쏘기",
      "description": "전략적으로 생각하고, 대상을 맞추고, 쏘고 모든 거품을 제거하세요.\n\n다양한 난이도의 수백 개의 레벨을 탐험하세요.\n\n모든 고양이를 آزاد하기 위해 최대한 정확하게 하세요.\n\n어려운 레벨에서 부스터를 구매하고 사용하세요.\n\n승리하기 위해 - 전장의 모든气球을 제거하세요.",
      "instructions": "- 가이드라인을 사용하여 목표를 정하고 퍼블을 폭발시켜주세요. 공들은 벽에서 반사될 수 있습니다 - 정확한 목표를 정할 때 이를 고려해주세요.\n- 다음 색상의气球이 카트에 보이게 됩니다. 이를 전략에 활용해주세요.\n- 쏘는 횟수 카운터를 잊지 마세요!",
      "genres": [
        "버블슈터"
      ],
      "tags": [
        "폭스",
        "고양이",
        "귀엽다"
      ]
    },
    "fr": {
      "title": "Sauvez les chats - Tire-bulle",
      "description": "Pensez stratégiquement, visez, tirez et éliminez toutes les bulles.\n\nExplorez des centaines de niveaux avec différents niveaux de difficulté.\n\nSoyez aussi précis que possible pour libérer tous les chats.\n\nAchetez et utilisez des boosters sur les niveaux difficiles.\n\nPour gagner - nettoyez le champ de tous les ballons.",
      "instructions": "- Utilisez la ligne directrice pour viser et exploser les bulles. Les balles peuvent rebondir sur les murs - tenez compte de cela lors de la visée.\n- Vous verrez la couleur suivante du ballon dans le chariot. Utilisez cette information dans votre stratégie.\n- N'oubliez pas le compteur de tirs !",
      "genres": [
        "Pop Balle"
      ],
      "tags": [
        "bulle",
        "chat",
        "mignon"
      ]
    }
  }
};
